import { PaginationTable } from '../../../../common/components';

const SubcontractorsPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <PaginationTable
      totalPages={totalPages}
      totalCount={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      entityName="subcontratista"
      entityNamePlural="subcontratistas"
    />
  );
};

export default SubcontractorsPagination;
